import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styled from 'styled-components';
import { FcGoogle } from 'react-icons/fc';
import { GiAbstract024 } from 'react-icons/gi'; // Abstract gene-like icon

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url('https://images.unsplash.com/photo-1533735380053-eb8d0759b24a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNjAzNTV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRuYSUyMGRhcmt8ZW58MHx8fHwxNzMxMjY5NTc3fDA&ixlib=rb-4.0.3&q=80&w=1080');
  background-size: cover;
  background-position: center;
`;

const LoginBox = styled.div`
  background: rgba(26, 26, 46, 0.9);
  border: 1px solid #303050;
  padding: 3rem;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  width: 400px;
`;

const Title = styled.h1`
  color: ${props => props.theme.colors.accent};
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  background: ${props => props.theme.colors.background};
  border: 1px solid #303050;
  border-radius: 5px;
  color: ${props => props.theme.colors.text};
  box-sizing: border-box; /* Important for padding to work */
`;

const Button = styled.button`
  width: 100%;
  padding: 0.75rem;
  border: none;
  border-radius: 5px;
  background: ${props => props.theme.colors.primary};
  color: white;
  font-size: 1rem;
  cursor: pointer;
  margin-bottom: 1rem;
  
  &:hover {
    opacity: 0.9;
  }
`;

const GoogleButton = styled(Button)`
  background: white;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

const ErrorMsg = styled.p`
  color: #FF5555;
`;

const ToggleMode = styled.a`
  color: ${props => props.theme.colors.accent};
  cursor: pointer;
  text-decoration: underline;
`;

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const { loginWithGoogle, loginWithEmail, signupWithEmail } = useAuth();
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    setError('');
    try {
      await loginWithGoogle();
      navigate('/create');
    } catch {
      setError('Failed to sign in with Google');
    }
  };
  
  const handleEmailAuth = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (isLogin) {
        await loginWithEmail(email, password);
      } else {
        await signupWithEmail(email, password);
      }
      navigate('/create');
    } catch (err) {
      setError(`Failed to ${isLogin ? 'sign in' : 'sign up'}. ${err.message}`);
    }
  };

  return (
    <LoginContainer>
      <LoginBox>
        <Title><GiAbstract024 /> Codex Vitae</Title>
        <GoogleButton onClick={handleGoogleLogin}>
          <FcGoogle /> Sign in with Google
        </GoogleButton>
        <p style={{color: '#aaa'}}>or</p>
        <form onSubmit={handleEmailAuth}>
          <Input 
            type="email" 
            placeholder="Email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
          />
          <Input 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
          />
          {error && <ErrorMsg>{error}</ErrorMsg>}
          <Button type="submit">{isLogin ? 'Login' : 'Sign Up'}</Button>
        </form>
        <ToggleMode onClick={() => setIsLogin(!isLogin)}>
          {isLogin ? "Need an account? Sign Up" : "Have an account? Login"}
        </ToggleMode>
      </LoginBox>
    </LoginContainer>
  );
};

export default LoginPage;